import SearchBar from 'antd-mobile/lib/search-bar';
export default SearchBar;



// WEBPACK FOOTER //
// ./components/search-bar/index.tsx